import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useDispatch } from "react-redux";
import analytics from "web/script/analytics/analytics";
import browser from "web/script/utils/browser";
import classnames from "classnames";
import environment from "web/script/modules/environment";
import PropTypes from "prop-types";
import { getHtmlProps } from "web/script/modules/html-tag-props";
import { gettext } from "web/script/modules/django-i18n";
import React, { useCallback, useEffect, useRef, useState } from "react";
import storage from "web/script/utils/storage";
import { useSmallBreakpoint } from "web/react/hooks/use-breakpoint/use-breakpoint";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import FollowDesignerButton from "web/react/components/follow-designer-button/follow-designer-button";
import { bannerDisabledByUser } from "web/redux/ducks/follow-designer-banner";
import styles from "./follow-sticky-banner.css";
var ONE_HOUR = 3600000;

function FollowStickyBanner(_ref) {
  var lystId = _ref.lystId,
      followedText = _ref.followedText,
      notFollowedText = _ref.notFollowedText,
      isAuthenticated = _ref.isAuthenticated,
      isFollowing = _ref.isFollowing,
      description = _ref.description,
      profileImage = _ref.profileImage,
      forceDisplay = _ref.forceDisplay,
      designerName = _ref.designerName,
      productTaxonomy = _ref.productTaxonomy;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      closed = _useState4[0],
      setClosed = _useState4[1];

  var wrapperRef = useRef(null);

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isIos = _useState6[0],
      setIsIos = _useState6[1];

  var pageSubType = environment.get("pageSubType");
  var dispatch = useDispatch(); // This is to check if to hide the banner when Follow button
  // in the top is visible

  var hideDUBanner = !useSmallBreakpoint();
  var useIosDUText = isIos && pageSubType.startsWith("designer") && environment.getFeature("mg_du_banner_ios_to_app");

  function displayBanner() {
    setShow(true);
    analytics.event("du_feed_banner", "banner_shown", "du_banner", true); // non interactive

    storage.remove("hideStickyBannerTimestamp");
  }

  var triggerBanner = useCallback(function (delay) {
    var hideStickyBannerTimestamp = storage.get("hideStickyBannerTimestamp");
    var timer;

    if (!hideStickyBannerTimestamp || hideStickyBannerTimestamp < new Date().getTime() - ONE_HOUR) {
      timer = setTimeout(displayBanner, delay);
    } else {
      dispatch(bannerDisabledByUser(true));
    }

    return function () {
      clearTimeout(timer);
    };
  }, [dispatch]);
  useEffect(function () {
    setIsIos(browser.ios); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [browser.ios]);
  useEffect(function () {
    if (closed || hideDUBanner) {
      return;
    }

    triggerBanner(5000);
  });
  useEffect(function () {
    if (closed || !hideDUBanner) {
      return;
    }

    if (forceDisplay) {
      triggerBanner(500);
    } else {
      setShow(false);
    }
  }, [forceDisplay, closed, triggerBanner, hideDUBanner]);

  function triggerClose() {
    setShow(false);
    setClosed(true); // update reducer state banner is disabled

    dispatch(bannerDisabledByUser(true));
    storage.set("hideStickyBannerTimestamp", new Date().getTime());
    analytics.event("du_feed_banner", "banner_hidden", "du_banner", true); // non interactive
  }

  var bannerClassNames = classnames(styles.stickyBanner, _defineProperty({}, styles.stickyBannerShow, show && !closed));
  var renderedProfileImage = "";

  if (profileImage) {
    renderedProfileImage = React.createElement("img", {
      src: profileImage,
      className: styles.imageProfile
    });
  }

  if (!description) {
    var designerNameProps = {
      class: styles.designerName
    };

    if (productTaxonomy) {
      description = gettext("designer_updates.get_updates_designer_category.in_spans", {
        designer_name_span_props: getHtmlProps(designerNameProps),
        designer_name: designerName,
        product_taxonomy: productTaxonomy
      });
    } else {
      description = gettext("designer_updates.get_updates_designer.in_spans", {
        designer_name_span_props: getHtmlProps(designerNameProps),
        designer_name: designerName
      });
    }
  }

  return React.createElement("div", {
    ref: wrapperRef
  }, React.createElement("div", {
    className: bannerClassNames
  }, React.createElement("div", {
    className: styles.wrapper
  }, React.createElement("div", null, renderedProfileImage, React.createElement("div", {
    className: styles.content,
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), React.createElement("div", null, React.createElement(FollowDesignerButton, {
    className: styles.button,
    lystId: lystId,
    followedText: followedText,
    notFollowedText: useIosDUText ? // "Download the Lyst App"
    gettext("app_download_large_banner.general.cta") : notFollowedText,
    isAuthenticated: isAuthenticated,
    isFollowing: isFollowing,
    analyticsParameters: ["du_feed_banner", "click_banner_cta", "du_banner"]
  }), React.createElement(CloseButton, {
    className: styles.closeButton,
    onClick: triggerClose
  })))));
}

export default FollowStickyBanner;
FollowStickyBanner.propTypes = {
  lystId: PropTypes.number,
  followedText: PropTypes.string,
  notFollowedText: PropTypes.string,
  isAuthenticated: PropTypes.string,
  isFollowing: PropTypes.string,
  description: PropTypes.string,
  profileImage: PropTypes.string,
  forceDisplay: PropTypes.bool,
  designerName: PropTypes.string,
  productTaxonomy: PropTypes.string
};